var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchAgainWhite1616 = function SvgSearchAgainWhite1616(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.517 9.648h-.533l-.18-.18a4.32 4.32 0 0 0 1.006-3.393 4.345 4.345 0 0 0-3.3-3.64c-2.826-.653-5.326 1.567-5.326 4.213h-1.4a.333.333 0 0 0-.207.594l2.267 1.833a.33.33 0 0 0 .473.007l1.934-1.86a.335.335 0 0 0-.234-.574h-1.5a2.995 2.995 0 0 1 2.974-3c1.626-.013 3.026 1.367 3.026 2.994a3.01 3.01 0 0 1-3 3.006c-.3 0-.593-.046-.866-.126a.64.64 0 0 0-.64.173c-.354.354-.214.967.26 1.107.393.113.813.18 1.246.18a4.3 4.3 0 0 0 2.814-1.047l.18.18v.527l2.846 2.833a.696.696 0 0 0 .987 0 .704.704 0 0 0 0-.993z"
  })));
};
export default SvgSearchAgainWhite1616;